export default __webpack_public_path__ + "static/media/golf-ball-concierge_edited_edited.7927be43.jpg";